import { Controller, useFormContext } from "react-hook-form";
import { SimpleMultiSelect } from "~/common/components/Select/SimpleMultiSelect";
import classNames from "classnames";
import { useHSAFacetData } from "~/features/selectionAssistant/housing/components/useHSAFacetData";
import { type RuntimeFilterItem } from "~/features/selectionAssistant/housing/types/FilterDefinitionV2";
import { Box, Typography } from "~/common/mui";

export interface RHFMultiSelectProps {
  className?: string;
  values: RuntimeFilterItem[];
  label?: string;
  name: string;
  "data-test-id"?: string;
}

export const RHFMultiSelect = ({ className, label, name, ...rest }: RHFMultiSelectProps) => {
  const { control } = useFormContext();

  return (
    <Box className={className}>
      {label && (
        <Typography variant="bodyMedium" sx={{ fontWeight: "bold", mb: 2.5 }}>{label}</Typography>
      )}
      <Controller
        control={control}
        name={name}
        render={({ field: { value, onChange } }) => (
          <SimpleMultiSelect
            value={value}
            onChange={(e) => {
              const selectedValues = e.target.value as unknown as string[];
              onChange(selectedValues);
            }}
            fullWidth={true}
            {...rest}
          />
        )}
      />
    </Box>
  );
};

export interface HousingMultiSelectProps extends Omit<RHFMultiSelectProps, "values" | "label"> {}

export const HousingMultiSelect = (props: HousingMultiSelectProps) => {
  const { values, label } = useHSAFacetData(props);
  return <RHFMultiSelect values={values} label={label} {...props} />;
};
